import {platform} from 'substance'
import OpenKeybindingEditorCommand from './commands/OpenKeybindingEditorCommand'
import KeybindingSettings from './components/KeybindingSettings'

import './scss/keybindingeditor.scss'

const KeybindingsPackage = {
    name: 'keybinding',
    configure: function(config) {
        config.addCommand('OpenKeybindingEditor', OpenKeybindingEditorCommand)

        if (platform.isMac) {
            config.addKeyboardShortcut('cmd+shift+k', {command: 'OpenKeybindingEditor'}, true, 'keybinding-modify-keyboard-shortcuts')
        }
        else {
            config.addKeyboardShortcut('ctrl+shift+k', {command: 'OpenKeybindingEditor'}, true, 'keybinding-modify-keyboard-shortcuts')
        }

        config.addLabel('keybinding-keyboard-shortcuts', {
            en: 'Keyboard shortcuts',
            sv: 'Kortkommandon'
        })

        config.addLabel('keybinding-modify-keyboard-shortcuts', {
            // en: 'Modify keyboard shortcuts',
            // sv: 'Ändra kortkommandon'
            en: 'View keyboard shortcuts',
            sv: 'Se kortkommandon'
        })

        config.addLabel('keybinding-modify-keyboard-shortcuts-message', {
            en: 'Press desired key combination and Enter. Escape to cancel.',
            sv: 'Tryck önskad knappkombination och Enter. Escape för att avbryta.'
        })

        config.addLabel('keybinding-restore-keyboard-shortcuts', {
            en: 'Restore default keyboard shortcuts',
            sv: 'Återställ kortkommandon'
        })

        config.addPluginModule(
            'se.infomaker.keybinding.settings',
            KeybindingSettings,
            'se.infomaker.npwriter.settings'
        )
    }
}

export {KeybindingsPackage}
